import { useCallback, useState } from 'react';
import { ConfirmState } from '../types';

export interface ConfirmDialogState {
  confirm: ConfirmState;
  ask: (
    title: string,
    message: string,
    okLabel: string,
    onConfirm: () => void,
  ) => void;
  closeConfirm: () => void;
  confirmOk: () => void;
}

const initialState: ConfirmState = {
  isOpen: false,
  title: '',
  message: '',
  okLabel: 'Löschen',
  onConfirm: null,
};

export const useConfirmDialog = (): ConfirmDialogState => {
  const [confirm, setConfirm] = useState<ConfirmState>(initialState);

  const ask = useCallback(
    (
      title: string,
      message: string,
      okLabel: string,
      onConfirm: () => void,
    ): void => {
      setConfirm({
        isOpen: true,
        title,
        message,
        okLabel: okLabel || 'Löschen',
        onConfirm,
      });
    },
    [],
  );

  const closeConfirm = useCallback((): void => {
    setConfirm(initialState);
  }, []);

  const confirmOk = useCallback((): void => {
    const { onConfirm } = confirm;
    setConfirm(initialState);
    if (onConfirm) onConfirm();
  }, [confirm]);

  return { confirm, ask, closeConfirm, confirmOk };
};
